import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, toRefs, useContext, watch } from '@nuxtjs/composition-api';
import { useMobile } from '~/core/composables/useMobile';
import { ACTIONS as SUCCESS_MODAL_ACTIONS } from '~/store/affility/user/feedback/modals/success/names';

interface Props {
    visible: boolean,
    title:string,
    desc:string,
    btnText:string,
    btnAttrs?:Record<string, unknown>,
    buttonVisible?: boolean,
    width?: string,
    closeOnClickModal?: boolean,
    closeOnPressEscape?: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SuccessModal',
  props: {
    visible: { type: Boolean },
    title: null,
    desc: null,
    btnText: { default: 'ok' },
    btnAttrs: null,
    buttonVisible: { type: Boolean, default: true },
    width: { default: 'min(412px, calc(100vw - 32px))' },
    closeOnClickModal: { type: Boolean, default: true },
    closeOnPressEscape: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { visible: boolean, title:string, desc:string, btnText:string, btnAttrs?:Record<string, unknown>, buttonVisible: boolean, width: string, closeOnClickModal: boolean, closeOnPressEscape: boolean };

const { store } = useContext();
const isMobile = useMobile();
const buttonSize = computed(() => isMobile.value ? 's' : 'm');



const {
    visible,
    title,
    desc,
    btnText,
    width,
    buttonVisible,
    closeOnClickModal,
    closeOnPressEscape,
} = toRefs(props);

const internalVisible = ref(visible.value);
const cancelPopup = store.dispatch.bind(null, `affility/user/feedback/modals/success/${SUCCESS_MODAL_ACTIONS.HIDE_SUCCESS_MODAL}`);
watch(visible, (value) => {
    internalVisible.value = value;
});
watch(internalVisible, (value) => {
    if (!value) {
        cancelPopup();
    }
});

return { __sfc: true,store, isMobile, buttonSize, props, visible, title, desc, btnText, width, buttonVisible, closeOnClickModal, closeOnPressEscape, internalVisible, cancelPopup }
}

})